/* ==========================================================================
   Bauer & Meyer — main-cart.js
   <cart-note>: saves the order note while typing (cart page). Quantity and
   remove are handled by <cart-items> in theme.js.
   ========================================================================== */

(() => {
  if (customElements.get('cart-note')) return;

  class CartNote extends HTMLElement {
    connectedCallback() {
      const field = this.querySelector('textarea');
      if (!field || !window.theme) return;
      const save = theme.utils.debounce(() => {
        fetch(`${theme.routes.cartUpdate}.js`, theme.utils.fetchConfig('json', { note: field.value })).catch(() => {});
      }, 600);
      field.addEventListener('input', save);
    }
  }

  customElements.define('cart-note', CartNote);
})();
